import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/manage-deputy-branch';

const list = (merchantId) => {
	return Client.get(`${baseUrl}/${merchantId}/deputyBranchLocations`, {
		status: 0,
	});
};

const find = (merchantId, id) => {
	return Client.get(`${baseUrl}/${merchantId}/deputyBranchLocations/${id}`);
};

const create = (
	merchantId,
	branchId,
	deputyCompanyId,
	deputyCompanyName,
	deputyAreaId,
	deputyAreaName,
	operateBy,
	stopFlag = false
) => {
	return Client.post(`${baseUrl}/${merchantId}/deputyBranchLocations`, {
		branchId,
		deputyCompanyId,
		deputyCompanyName,
		deputyAreaId,
		deputyAreaName,
		operateBy,
		stopFlag,
	});
};

const update = (
	merchantId,
	id,
	branchId,
	deputyCompanyId,
	deputyCompanyName,
	deputyAreaId,
	deputyAreaName,
	operateBy,
	stopFlag = false
) => {
	return Client.put(`${baseUrl}/${merchantId}/deputyBranchLocations/${id}`, {
		branchId,
		deputyCompanyId,
		deputyCompanyName,
		deputyAreaId,
		deputyAreaName,
		operateBy,
		stopFlag,
	});
};

const remove = (merchantId, id, operateBy) => {
	return Client.del(`${baseUrl}/${merchantId}/deputyBranchLocations/${id}`, {
		operateBy,
	});
};

const locationList = (merchantId) => {
	return Client.get(
		`/gateway/numbat-api/api/vs/manage-deputy-external/${merchantId}/deputyLocations`
	);
};

export default {
	list,
	find,
	create,
	update,
	remove,
	locationList,
};
